import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import Default from '../../contenedores/Default';

import { useFetchReporte } from '../../hooks/useFetchReporte';

import CabeceroReportes from '../../componentes/CabeceroReportes';
import ListaConfiguracion from '../../componentes/ListaConfiguracion';
import Tabla from '../../componentes/Table';

import endpoints, {
  ENFERMEDADES,
  TRAMPAS,
} from '../../configuraciones/endpoints';

import { DatePickerTypes } from '../../constantes/datePickerTypes';

const datosLista = {
  labelProp: 'nombre',
  headerLista: 'Nombre',
  title: 'Reporte de Plagas & Enfermedades',
  data: [
    {
      id: 1,
      nombre: 'P&E en plantas',
      subTitle: 'Plagas/Enfermedades Encontradas',
    },
    {
      id: 2,
      nombre: 'P&E en trampas',
      subTitle: 'Listado por plaga/enfermedad',
    },
  ],
};

const cabeceros = [
  { label: 'SITIO', key: 'sitio', align: 'left' },
  { label: 'INVERNADERO', key: 'invernadero', align: 'left' },
  { label: 'NAVE', key: 'Nave', align: 'left' },
  { label: 'Trampa', key: 'Trampa', align: 'left' },
  { label: 'PLAGA/ENFERMEDAD', key: 'Enfermedad', align: 'left' },
  { label: 'CANTIDAD', key: 'cantidad', align: 'left' },
];

const ReporteTrampas = ({ history }) => {
  const { registros } = useSelector((store) => store.listados);
  const { data, formData, buscar, onChange, onDelete } = useFetchReporte(
    {
      trampas: endpoints.base.busqueda(TRAMPAS),
      enfermedades: endpoints.base.busqueda(ENFERMEDADES),
    },
    endpoints.reporteEnfermedadesTrampas(),
    { formatoFecha: 'YYYY-MM-DD' },
  );

  const handleTodosSelected = useCallback(() => {
    const { sitios, invernaderos, naves, trampas, enfermedades, fecha } =
      formData;

    const params = {
      sitios,
      naves,
      invernaderos,
      trampas,
      enfermedades,
      fecha: moment(fecha).format('YYYY-MM-DD'),
    };

    return params;
  }, [formData]);

  const onSubMenuClick = (id) => {
    if (id === 1) {
      history.push(`/reportes/enfermedades`);
    } else {
      history.push(`/reportes/trampas`);
    }
  };

  return (
    <Default
      mostrarLista={
        <ListaConfiguracion
          datosLista={datosLista}
          onClick={onSubMenuClick}
          initOpcion={1}
        />
      }
    >
      <CabeceroReportes
        data={data}
        formData={formData}
        buscar={buscar}
        onChange={onChange}
        onDelete={onDelete}
        handleTodosSelected={handleTodosSelected}
        selects={{
          sitio: { width: 4, show: true },
          invernadero: { width: 4, show: true },
          nave: { width: 4, show: true },
          trampa: { width: 3, show: true },
          enfermedad: { width: 3, show: true },
          fecha: { width: 3, show: true, type: DatePickerTypes.date },
        }}
        endpoint={endpoints.reporteEnfermedadesTrampas()}
        method="POST"
      />
      <Tabla
        headers={cabeceros}
        rows={registros.rows.length > 0 ? registros.rows : []}
        count={registros.count}
        showActions={false}
      />
    </Default>
  );
};

export default ReporteTrampas;
